export default "__VITE_ASSET__qSNqAxHt__"